module.exports = __webpack_public_path__ + "src/assets/img/selector-stub-dachiev.864bcbd8.svg";